import React, { useState, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift, ChevronDown } from 'lucide-react';
const bonosData = [{
  title: 'BONO 1 — Banco de Calentamientos',
  value: '$12.000',
  content: '30 calentamientos específicos para telas, listos para usar. Organizados por objetivo: movilidad, fuerza y coordinación. Con variantes para distintas edades y niveles. Versión corta de 10 minutos y versión completa de 20 minutos. Nunca más empezar la clase sin saber cómo arrancar.',
  icon: '🔥'
}, {
  title: 'BONO 2 — Diccionario de Figuras de Telas',
  value: '$10.000',
  content: 'Nombre técnico, descripción y puntos clave de 60 figuras organizadas por nivel. Descripción de agarre, posición corporal y errores frecuentes de cada figura. Ideal para estandarizar el vocabulario en clase y hablar con precisión profesional.',
  icon: '📚'
}, {
  title: 'BONO 3 — Guía de Corrección Verbal y Física',
  value: '$9.000',
  content: 'Qué decir y cómo asistir para corregir sin lastimar ni bloquear al alumno. Frases exactas para corrección verbal, técnica de contacto seguro para asistir figuras y cómo dar feedback positivo que motive y retenga.',
  icon: '🗣️'
}, {
  title: 'BONO 4 — Protocolos de Seguridad y Primeros Auxilios',
  value: '$10.000',
  content: 'Actuá rápido y bien ante cualquier situación en clase. Protocolo ante caídas, mareos y calambres, cómo hacer revisión de telas y puntos de anclaje y qué hacer antes, durante y después de un incidente. La tranquilidad que todo profe necesita.',
  icon: '🛡️'
}, {
  title: 'BONO 5 — Clases Especiales y Temáticas',
  value: '$9.000',
  content: '8 clases temáticas completas listas para usar: Halloween, verano, show, clases abiertas y más. Cómo incorporar música y ambientación para crear experiencias memorables. Ideas para eventos especiales que fidelizan alumnos.',
  icon: '🎭'
}, {
  title: 'BONO 6 — Guía para Dar Clases Online de Telas',
  value: '$8.000',
  content: 'Adaptá tu metodología al formato virtual sin perder calidad ni seguridad. Cómo estructurar una clase de telas online, configuración y comunicación efectiva y cómo mantener la seguridad a distancia.',
  icon: '💻'
}];
export const BonusSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 md:py-20 bg-gray-900 text-white relative overflow-hidden" data-id="element-15">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-accent/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-16"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-yellow-500/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-17"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-12" data-id="element-19">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-yellow-400/20 to-accent/20 text-yellow-400 mb-3 md:mb-6 border border-yellow-400/30" data-id="element-20">
            <Gift size={24} className="md:hidden" data-id="element-21" />
            <Gift size={32} className="hidden md:block" data-id="element-22" />
          </div>
          <h2 className="text-2xl md:text-5xl font-bold font-serif mb-2 md:mb-4 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300" data-id="element-23">
            Más los 6 Bonos Estratégicos
          </h2>
          <p className="text-base md:text-xl text-gray-400 font-medium" data-id="element-24">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </motion.div>

        <div className="space-y-3 md:space-y-4" data-id="element-25">
          {bonosData.map((bono, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="relative group" data-id="element-26">
                {/* Glow effect on hover */}
                <div className="absolute -inset-0.5 bg-gradient-to-r from-yellow-400/0 via-yellow-400/30 to-yellow-400/0 rounded-xl md:rounded-2xl opacity-0 group-hover:opacity-100 transition duration-500 blur-sm" data-id="element-27"></div>

                <div className="relative bg-gray-800 border border-gray-700 hover:border-yellow-500/50 rounded-lg md:rounded-xl overflow-hidden transition-colors duration-300" data-id="element-28">
                  <button className="w-full text-left px-4 py-3 md:px-6 md:py-5 flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-29">
                    <div className="flex items-center gap-3 md:gap-4 pr-2 md:pr-4 w-full" data-id="element-30">
                      <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gray-700 flex items-center justify-center text-xl md:text-2xl flex-shrink-0 border border-gray-600 shadow-inner" data-id="element-31">
                        {bono.icon}
                      </div>
                      <div className="flex-grow" data-id="element-32">
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-1 sm:gap-3" data-id="element-33">
                          <h3 className={`font-serif text-base md:text-xl font-bold transition-colors ${isOpen ? 'text-yellow-400' : 'text-white group-hover:text-yellow-100'}`} data-id="element-34">
                            {bono.title}
                          </h3>
                          <div className="flex items-center gap-2 flex-shrink-0" data-id="element-35">
                            <span className="text-red-400 line-through text-xs md:text-sm font-medium" data-id="element-36">
                              Valor: {bono.value}
                            </span>
                            <span className="bg-accent/20 text-accent border border-accent/30 px-2 py-0.5 rounded text-[10px] md:text-xs font-bold uppercase tracking-wide" data-id="element-37">
                              GRATIS
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <motion.div animate={{
                  rotate: isOpen ? 180 : 0
                }} transition={{
                  duration: 0.3
                }} className={`flex-shrink-0 ml-2 ${isOpen ? 'text-yellow-400' : 'text-gray-500'}`} data-id="element-38">
                      <ChevronDown size={20} className="md:hidden" data-id="element-39" />
                      <ChevronDown size={24} className="hidden md:block" data-id="element-40" />
                    </motion.div>
                  </button>
                  <AnimatePresence initial={false} data-id="element-41">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-42">
                        <div className="px-4 pb-4 md:px-6 md:pb-6 pt-2 text-sm md:text-base text-gray-300 leading-relaxed border-t border-gray-700 bg-gray-800/50" data-id="element-43">
                          {bono.content}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-8 md:mt-12 text-center" data-id="element-44">
          <div className="inline-block bg-gradient-to-r from-gray-800 to-gray-800 border border-yellow-500/30 rounded-full px-5 py-3 md:px-8 md:py-4 shadow-[0_0_15px_rgba(234,179,8,0.15)]" data-id="element-45">
            <p className="text-sm md:text-lg font-medium text-gray-200" data-id="element-46">
              Valor total de los 6 bonos{' '}
              <span className="line-through text-red-400/80 mx-1 md:mx-2" data-id="element-47">
                $58.000
              </span>
              <span className="text-yellow-400 font-bold text-base md:text-xl drop-shadow-md" data-id="element-48">
                🎁 GRATIS
              </span>{' '}
              — Incluidos siempre
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};